import { PaginatedPartogramRecords } from "@/components/SurgicalCenter/SurgicalAttendance/OperatingRoom/MedicalSurgicalActView/PartogramFetusCharts";

type HeartRateParams = {
	data: PaginatedPartogramRecords;
	heartRate: Array<number | null>;
};

export function heartRateOptions({ data, heartRate }: HeartRateParams) {
	return {
		options: {
			grid: {
				show: true,
				borderColor: "#5E6278",
				strokeDashArray: 3,
				row: {
					colors: ["transparent"],
				},
				column: {
					colors: ["transparent"],
				},
				xaxis: {
					lines: {
						show: true,
					},
				},
			},
			chart: {
				id: "heart-rate-line",
				toolbar: {
					show: false,
				},
			},
			stroke: {
				curve: "smooth" as "smooth",
				width: 2,
			},
			markers: {
				size: 10,
				shape: "circle" as "circle",
			},
			dataLabels: {
				enabled: false,
			},
			xaxis: {
				min: 10,
				range: data.results?.length,
				tickPlacement: "between",
				labels: {
					show: false,
				},
				categories: data.results?.map(() => ""),
			},
			yaxis: [
				{
					min: 0,
					max: 200,
					tickAmount: 10,
					title: {
						text: "BFC - Batimento/Min",
						style: {
							fontSize: "16px",
							fontWeight: "600",
							fontFamily: "Inter, sans-serif",
						},
					},
					labels: {
						formatter(value: number) {
							if (value < 80 || value > 180) {
								return "";
							}

							return String(value);
						},
					},
				},
				{
					min: 0,
					max: 10,
					opposite: true,
					show: true,
					labels: {
						style: { cssClass: "invisible" },
					},
					title: {
						text: "PLACEHOLDER",
						style: { cssClass: "invisible" },
					},
				},
			],
		},
		series: [{ name: "BFC - Batimento/Min", data: heartRate }],
	};
}
